export default __webpack_public_path__ + "static/media/MaisonNeue-Medium.6eb72d12.woff2";